import React, {useState, useEffect, useMemo, useCallback} from 'react'
import {
  Button,
  TextField,
  Box,
  FormControl,
  Typography,
  InputLabel,
  FormControlLabel,
  Checkbox,
  CardMedia,
  Radio,
  RadioGroup,
  TextareaAutosize,
  Autocomplete,
  Grid
} from '@mui/material'
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import dayjs from 'dayjs'
import {DatePicker, LocalizationProvider} from '@mui/x-date-pickers'
import CustomDatePicker from '../datePicker/customdate';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs'
import {useHistory} from 'react-router-dom'
import GetICDValues from './GetICDValues'
import {TimePicker} from '@mui/x-date-pickers/TimePicker'
import {toast} from 'react-toastify'
import ClearIcon from '@mui/icons-material/Clear'
import AddressForm from '../Adress/AddressForm'
import PhoneNumber from './PhoneNumber'
import NumberField from './NumberField'
import SocialSecurityNumberField from './SSNField'
import { RootState } from '../../../setup'
import { useSelector } from 'react-redux'
import PhysicalTherapistDialog from '../../pages/Notes/Physical_Therapist_Notes/new/PhysicalTherapistDialog';
import WoundDialog from '../../pages/Notes/Physical_Therapist_Notes/new/WoundDialog';
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import SearchableSelect from './SearchableSelect';
import SpeechTherapyDialog from '../../pages/Notes/Speech_therapy/SpeechTherapyDialogue';
import CaregiverNotesDialog from '../../pages/Notes/Caregiver_Notes/Notes/CaregiverNotesDialogue';
import FrequencyDateRangePicker from '../NoteType/NoteType';
import NursesAssessmentDialogue from '../../pages/Notes/Nurses_Notes/NursesPainAssessmentDialogue';
import VascularAccessDialogue from '../../pages/Notes/Nurses_Notes/VascularAccessDialogue';
import BehaviorMappingTable from '../BehaviorMapping/BehaviorMappingTable';
import SmartTextarea from '../SmartTextarea';
const selectAuth = (state: RootState) => state.timeZone.timeZone

dayjs.extend(utc);
dayjs.extend(timezone);

function formatToMMDDYYYY(dateValue: any) {
  let dateObj;
  if (!dateValue) return '';
  if (typeof dateValue === 'string' || dateValue instanceof String) {
    // Always use primitive string
    dateObj = new Date(dateValue.toString());
  } else if (dateValue instanceof Date) {
    dateObj = dateValue;
  } else if (typeof dateValue === 'object' && ('$y' in dateValue && '$M' in dateValue && '$D' in dateValue)) {
    // dayjs object
    return `${(dateValue.$M + 1).toString().padStart(2, '0')}-${dateValue.$D.toString().padStart(2, '0')}-${dateValue.$y}`;
  } else {
    return '';
  }
  if (isNaN(dateObj.getTime())) return '';
  const year = dateObj.getFullYear().toString();
  const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
  const day = dateObj.getDate().toString().padStart(2, '0');
  return `${month}-${day}-${year}`;
}

const DynamicForm = ({fields, data, onSubmit, buttons, typographySx, disabled, setFormValues, noteType}: any) => {
  const [formData, setFormData] = useState(data)
  const [selectedOptions, setSelectedOptions] = useState([])
  const [selectedImage, setSelectedImage] = useState('')
  const [selectedFile, setSelectedFile] = useState<File | null>(null)
  const [filePreview, setFilePreview] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const history = useHistory()
  const icon = <CheckBoxOutlineBlankIcon fontSize='small' />
  const checkedIcon = <CheckBoxIcon fontSize='small' />
  const timeZone = useSelector(selectAuth)
  const dateKeys = ["birthDate", "reportedOn", "creationDate"];
  const [assessmentRecords, setAssessmentRecords] = useState([]);
  const [goalRecords, setGoalRecords] = useState([]);
  const [goalName, setGoalName] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [woundRecords, setWoundRecords] = useState([]);
  const [woundDialogOpen, setWoundDialogOpen] = useState(false);
  const [nursesAssessmentDialogOpen, setNursesAssessmentDialogOpen] = useState(false);
  const [vascularAccessDialogOpen, setVascularAccessDialogOpen] = useState(false);

  const groupedFields = useMemo(() => 
    fields?.reduce((acc: {[x: string]: any[]}, field: {rowNumber: any}) => {
      const {rowNumber} = field
      if (!acc[rowNumber]) {
        acc[rowNumber] = []
      }
      acc[rowNumber].push(field)
      return acc
    }, {})
  , [fields]);

  useEffect(() => {
    const initialOptions = fields.reduce((acc, field) => {
      if (field.type === 'multiSelect' && data[field.name]) {
        acc[field.name] = data[field.name]
      }
      return acc
    }, {})
    setSelectedOptions(initialOptions)
  }, [fields])

  useEffect(() => {
    if(data?.painLocation && assessmentRecords.length === 0){
      setAssessmentRecords(data?.painLocation)
    }
    // Convert any pre-selected dates to MM-DD-YYYY format
    const convertedData = { ...data };
    fields.forEach(field => {
      if (field.type === 'date' && convertedData[field.name]) {
        convertedData[field.name] = formatToMMDDYYYY(convertedData[field.name]);
      }
    });
    setFormData(convertedData);
  }, [assessmentRecords, fields]);
  
    useEffect(() => {
    if(data?.longTermGoals && goalRecords.length === 0){
      setGoalRecords(data?.longTermGoals)
    }
    setFormData(data)
  }, [goalRecords])

    useEffect(() => {
      if (data?.tasks) {
        setFormData({
          ...data,
          goalName: data.tasks || [],
        });
      }
    }, [goalName]);
  useEffect(() => {
    if (formData?.programId?.length === 0 && formData?.clientId.length !== 0) {
      
      setFormData((prevData) => ({
        ...prevData,
        clientId: '',
      }))
    }
  }, [formData?.programId, formData?.clientId])

  useMemo(() => {
    const programField = fields?.find((field) => field?.name === 'programId')
    const clientField = fields?.find((field) => field?.name === 'clientId')
    const clientFieldIndex = fields?.findIndex((field) => field?.name === 'clientId')

    if (programField && clientField) {
      fields[clientFieldIndex].disabled = formData?.programId?.length === 0
    }
  }, [formData?.programId])
  

  const handleInputChange = useCallback((
    name: string,
    value: boolean | string | number | Date | File,
    checked: boolean | string,
    type: string | undefined
  ) => {
    setFormData((prevData: any) => {
      if (type === 'checkbox') {
        let updatedValue
        if (prevData[name] === undefined) {
          updatedValue = [value]
        } else {
          updatedValue = prevData[name].includes(value)
            ? prevData[name].filter((item: string | number | Date) => item !== value)
            : [...prevData[name], value]
        }

        return {
          ...prevData,
          [name]: updatedValue,
        }
      } else if (type === 'checkboxBoolean') {
        return {
          ...prevData,
          [name]: checked,
        }
      } else {
        return {
          ...prevData,
          [name]: value,
        }
      }
    })

    // Move setFormValues outside of setFormData
    if (type !== 'checkbox' && type !== 'checkboxBoolean') {
      setFormValues && setFormValues((prevData: any) => ({
        ...prevData,
        [name]: value,
      }))
    }
  }, []);

  const handleDateInputChange = (
    name: string,
    value: boolean | string | number | Date | File,
    checked: boolean | string,
    type: string | undefined,
    required?: boolean
  ) => {
    setFormData((prevData: any) => {
      let updatedData = { ...prevData, [name]: value };
     
  
      if (required && (!value || value === '' || value === 'Invalid date')) {
        updatedData = { ...updatedData, [`${name}Error`]: true };
      } else {
        updatedData = { ...updatedData, [`${name}Error`]: false };
      }
  
      return updatedData;
    });
  };
  
  
  const handleImageChange = (event: any) => {
    const Image = event.target.files[0]
    if (Image) {
      const imageUrl = URL.createObjectURL(Image)
      setSelectedImage(imageUrl)
      handleInputChange('img', Image, '', 'image')
    }
  }
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files[0]

    if (file) {
      const allowedMimeTypes = [
        'application/pdf',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      ]

      if (allowedMimeTypes.includes(file.type)) {
        setSelectedFile(file)
        handleInputChange('file', file, '', 'file')
      } else {
        toast.error('Invalid file type. Please select a valid file.')
        event.target.value = ''
        return
      }

      const reader = new FileReader()
      reader.onload = (e) => {
        if (typeof e.target.result === 'string') {
          setFilePreview(e.target.result)
        } else {
          // Handle the case where result is an ArrayBuffer, if needed.
          setFilePreview('')
        }
      }
      reader.readAsDataURL(file)
    } else {
      setFilePreview('')
    }
  }

  // const handleDeleteFile = () => {
  //   setSelectedFile(null)
  //   const file = formData.file
  //   axios
  //     .delete('/deleteFile/' + file)
  //     .then((response) => {
  //       console.log(response.data.message)
  //       setFormData((prevFormData) => ({
  //         ...prevFormData,
  //         file: null,
  //       }))
  //     })
  //     .catch((error) => {
  //       console.error(error)
  //       // Handle errors here
  //     })
  //   setFilePreview('')
  // }
  const handleDeleteImage = () => {
    setSelectedImage('')
  }

  // const checkValidation = () => {
  //   return new Promise((resolve, reject) => {
  //     let validData = true
  //     for (let i = 0; i < fields.length; i++) {
  //       if (fields[i].validation && formData[fields[i].name]) {
  //         if (!fields[i].validation.pattern.test(formData[fields[i].name])) {
  //           validData = false
  //           break
  //         }
  //       }
  //     }
  //     if (validData) {
  //       resolve(validData)
  //     } else {
  //       reject(new Error('Invalid values being submitted'))
  //     }
  //   })
  // }

  const validateFields = (fields, formData) => {
    let hasErrors = false;
  
    fields.forEach(field => {
      // Skip section headings or non-input objects
      if (field.sectionHeading || !field.name) {
        return;
      }
  
      const value = formData[field.name];
  
  
      // Skip validation if the field is not required and the value is undefined, null, or an empty string
      // Special case: Allow 0 for number fields
      if (!field.required && (value === undefined || value === null || String(value).trim() === '') && value !== 0) {
        return;
      }
  
      // Validate required fields or fields with a value
      if (
        (field.required && (value === undefined || value === null || String(value).trim() === '') && value !== 0) || // Required field is missing
        (field.validation && value !== undefined && value !== null && value !== 0 && !field.validation.pattern.test(String(value))) // Field fails validation
      ) {
        hasErrors = true; // Set the error flag
      }
    });
  
    return hasErrors; // Return true if any errors are found, otherwise false
  };
  

  const convertDatesToUTC = (data) => {
    const updatedData = { ...data };

    Object.keys(updatedData).forEach((key) => {
        if (dateKeys.includes(key)) {
            const value = updatedData[key];
    
            if (value && !isNaN(new Date(value).getTime())) {
                const currentTimeUTC = new Date().toISOString().split('T')[1];
                updatedData[key] = `${value}T${currentTimeUTC}`
            }
        }
    });
    return updatedData;
};


const handleSubmit = async (e) => {
  e.preventDefault();
  setIsLoading(true);
  // const hasValidationErrors = fields.some((field) => {
  //   if (field.sectionHeading || !field.name || field.type === 'button') return false;

  //   const value = formData[field.name];

  //   if (field.type === 'date' && field.required && (!value || value.trim() === '')) {
  //     setFormData((prevData) => ({
  //       ...prevData,
  //       [`${field.name}Error`]: true,
  //     }));
  //     return true;
  //   }

  //   if (field.required && (value === undefined || value === null )) {
  //     setFormData((prevData) => ({
  //       ...prevData,
  //       [`${field.name}Error`]: true,
  //     }));
  //     // toast.error(`${field.label} is required`);
  //     return true;
  //   }

  //   return false;
  // });

  // if (hasValidationErrors) {
  //   setIsLoading(false);
  //   // toast.error('Please fix the validation errors before submitting');
  //   return;
  // }
  // Validate all fields before submission
  // const hasValidationErrors = fields.some(field => {
  //   // Skip section headings, non-input objects, or button fields
  //   if (field.sectionHeading || !field.name || field.type === 'button') {
  //     return false;
  //   }

  //   // Handle scoring level fields specially
  //   if (field.name.includes('levelName') || field.name.includes('levelAcronym')) {
  //     const index = parseInt(field.name);
  //     const levelData = formData.scoringLevels?.[index];
      
  //     if (!levelData) {
  //       toast.error(`Validation failed for ${field.name}: No data found for level ${index}`);
  //       return true;
  //     }

  //     const fieldName = field.name.replace(`${index}`, '');
  //     const value = levelData[fieldName];

  //     if (field.required && (!value || String(value).trim() === '')) {
  //       toast.error(`Validation failed for ${field.name}: Required field is empty`);
  //       return true;
  //     }

  //     if (field.validation && value && !field.validation.pattern.test(String(value))) {
  //       toast.error(`Validation failed for ${field.name}: Value does not match pattern`);
  //       return true;
  //     }

  //     return false;
  //   }

  //   const value = formData[field.name];


  //   // Handle required field validation
  //   if (field.required) {
  //     // For multiSelect fields
  //     if (field.type === 'multiSelect') {
  //       if (!value || value.length === 0) {
  //         toast.error(`Validation failed for ${field.name}: Required multiSelect is empty`);
  //         return true;
  //       }
  //     }
  //     // For select fields
  //     else if (field.type === 'select') {
  //       if (!value) {
  //         toast.error(`Validation failed for ${field.name}: Required select is empty`);
  //         return true;
  //       }
  //     }
  //     // For all other fields
  //     else if (value === undefined || value === null || String(value).trim() === '') {
  //       toast.error(`Validation failed for ${field.name}: Required field is empty`);
  //       return true;
  //     }
  //   }

  //   // Handle field-specific validation for non-empty values
  //   if (field.validation && value) {
  //     // Skip validation for empty optional fields
  //     if (!field.required && (value === undefined || value === null || String(value).trim() === '')) {
  //       return false;
  //     }

  //     // For multiSelect fields, validate each selected value
  //     if (field.type === 'multiSelect') {
  //       const hasInvalidValue = value.some(option => !field.validation.pattern.test(String(option.value)));
  //       if (hasInvalidValue) {
  //         toast.error(`Validation failed for ${field.name}: MultiSelect has invalid value`);
  //       }
  //       return hasInvalidValue;
  //     }
  //     // For all other fields
  //     const isValid = field.validation.pattern.test(String(value));
  //     if (!isValid) {
  //       toast.error(`Validation failed for ${field.name}: Value does not match pattern`);
  //     }
  //     return !isValid;
  //   }

  //   return false;
  // });

  // if (hasValidationErrors) {
  //   setIsLoading(false);
  //   toast.error('Please fix the validation errors before submitting');
  //   return;
  // }

  try {
    const convertedData = convertDatesToUTC(formData);
    fields.forEach(field => {
      if (field.type === 'date' && convertedData[field.name]) {
        convertedData[field.name] = formatToMMDDYYYY(convertedData[field.name]);
      }
    });
    const dataToSubmit = {
      ...convertedData,
      ...(assessmentRecords.length > 0 && { assessmentRecords }),
      ...(woundRecords.length > 0 && { woundRecords }),
      ...(goalRecords.length > 0 && { goalRecords }),
      ...(goalName.length > 0 && { goalName }),
      painAsessment: data?.painAsessment || [],
      vascularAcess: data?.vascularAcess || [],
      
    };
    onSubmit(dataToSubmit);
    setFormData(dataToSubmit);
  } catch (err) {
    toast.error(err.message || "Submission failed");
  } finally {
    setIsLoading(false);
  }
};



  const handleAutocompleteChange = (name: string, newValue: string | number | Date) => {
    handleInputChange(name, newValue, true, 'autocomplete')
  }

  const handleSearchableSelectChange = (name: string, newValue: any) => {
    if (newValue) {
      handleInputChange(name, newValue.value, true, 'searchableSelect')
    } else {
      handleInputChange(name, null, true, 'searchableSelect')
    }
  }

  const handleBehaviorDataChange = useCallback((behaviorData: any) => {
    console.log('Behavior data received:', behaviorData)
    setFormData((prev: any) => ({
      ...prev,
      behaviorsMapping: behaviorData.behaviorsMapping,
    }))
  }, [])

  return (
    <>
      <form onSubmit={handleSubmit}>
        {Object.keys(groupedFields)?.map((rowNumber, index) => {
          const fieldsInRow = groupedFields[rowNumber]
          const sectionHeadingField = fieldsInRow?.find(
            (field: {sectionHeading: any}) => field.sectionHeading
          )
          const addressInfo = fieldsInRow.filter(
            (field: {addressInfo: boolean}) => field?.addressInfo
          )
          const mailingInfo = fieldsInRow.filter(
            (field: {mailingInfo: boolean}) => field?.mailingInfo
          )
           const isNoteType = fieldsInRow.filter(
            (field: {noteType: boolean}) => field?.noteType
          )
           const isTargetAndBehaviour = fieldsInRow.filter(
            (field: {targetAndBehaviour: boolean}) => field?.targetAndBehaviour && noteType === 'DAILY'
          )
          return (
            <div key={index}>
              {sectionHeadingField && (
                <Typography
                  sx={
                    typographySx
                      ? typographySx
                      : {
                          fontSize: '16px',
                          fontWeight: 'bold',
                          marginBottom: '0.5rem',
                          marginLeft: '1rem',
                        }
                  }
                  color='primary'
                >
                  {sectionHeadingField.sectionHeading}
                </Typography>
              )}
              {(addressInfo.length > 0 || mailingInfo.length > 0) && (
                <AddressForm
                  addressInfo={addressInfo && addressInfo[0]}
                  mailingInfo={mailingInfo && mailingInfo[0]}
                  formData={formData}
                  setFormData={setFormData}
                  disabled={addressInfo && addressInfo[0]?.disabled || mailingInfo && mailingInfo[0]?.disabled}
                />
              )}
              {(isTargetAndBehaviour.length > 0) && (
                <Box sx={{width: '100%', padding: '15px'}}>
                  <BehaviorMappingTable
                    onBehaviorDataChange={handleBehaviorDataChange}
                    canAddNew={true}
                    showDeleteButton={true}
                    initialTargetBehaviour={formData?.initialTargetBehaviour}
                    initialReplacementBehaviour={formData?.initialReplacementBehaviour}
                    initialTargetIds={formData?.initialTargetIds}
                    initialReplacementIds={formData?.initialReplacementIds}
                  />
                </Box>
                
              )}
              <div
                className='row g-3'
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginBottom: '1rem',
                  paddingLeft: '1rem',
                  paddingRight: '1rem',
                }}
              >
                {fieldsInRow?.map((field: any, index: React.Key) => {
                  if (field.sectionHeading) {
                    return null
                  }
                  if (
                    field.type === 'text' ||
                    field.type === 'email' ||
                    field.type === 'password'
                  ) {
                    return (
                      <div
                        key={field.name}
                        className={
                          field?.className
                            ? field.className
                            : `col-12 col-sm-6 col-md-6 
                        ${fieldsInRow.length === 1 && 'col-lg-12 col-md-12 col-sm-12'}
                         ${fieldsInRow.length === 2 && 'col-lg-6 col-md-6 col-sm-6'}
                         ${fieldsInRow.length === 3 && 'col-lg-4 col-md-4 col-sm-4'}
                         ${
                           fieldsInRow.length === 4 &&
                           (field.label === 'Comment' || field.label === 'Dosage')
                             ? 'col-lg-4 col-md-4 col-sm-3'
                             : 'col-lg-3 col-md-3 col-sm-3'
                         }
                         ${fieldsInRow.length === 5 && 'col-lg-3 col-md-3 col-sm-3'}`
                        }
                      >
                        <TextField
                          sx={field.sx || {}}
                          defaultValue={field.defaultValue ? field.defaultValue : undefined}
                          label={field.label}
                          variant='outlined'
                          type={field.type}
                          placeholder={field.placeholder}
                          size='small'
                          name={field.name}
                          value={field.value ? field.value : formData[field.name] || ''}
                          disabled={field?.disabled || disabled}
                          onChange={(e) => {
                            if (field.onChange) {
                              field.onChange(
                                e.target.name,
                                e.target.value,
                                '',
                                e.target.type,
                                field.index
                              )
                            }
                            handleInputChange(e.target.name, e.target.value, '', e.target.type)
                          }}
                          required={field.required || false}
                          className='textField'
                          error={Boolean(
                            field.validation &&
                              formData[field.name] &&
                              !field.validation.pattern.test(formData[field.name])
                          )}
                          helperText={
                            field.validation &&
                            formData[field.name] &&
                            !field.validation.pattern.test(formData[field.name])
                              ? field.validation.message
                              : ''
                          }
                        />
                      </div>
                    )
                  } else if (field.type === 'phoneNumber') {
                    return (
                      <div
                        key={field.name}
                        className={
                          field?.className
                            ? field.className
                            : `col-12 col-sm-6 col-md-6 
                        ${fieldsInRow.length === 1 && 'col-lg-12 col-md-12 col-sm-12'}
                         ${fieldsInRow.length === 2 && 'col-lg-6 col-md-6 col-sm-6'}
                         ${fieldsInRow.length === 3 && 'col-lg-4 col-md-4 col-sm-4'}`
                        }
                      >
                        <PhoneNumber
                          formData={formData}
                          handleInputChange={handleInputChange}
                          field={field}
                          disabled={disabled}
                        />
                      </div>
                    )
                  } else if (field.type === 'sectionTitle') {
                    return (
                        <Typography
                          variant='h3'
                          sx={{paddingTop: '1.5rem', paddingBottom: '1.5rem'}}
                          fontSize={20}
                          fontWeight={'bold'}
                        >
                          {field.title}
                        </Typography>
                    )
                  }
                     else if (field.type === 'bulletPoint') {
                     return (
                         <Typography
                           variant='h4'
                           sx={{
                              paddingTop: '1.5rem', 
                              whiteSpace: 'pre-wrap',
                              color: '#3E3E3E',
                              display: 'flex',
                              justifyContent: 'space-between',
                              gap: 2,
                            }}
                           fontSize={12}
                         >
                           <span style={{ flex: 1 }}>{field.bullet1}</span>
                           <span style={{ flex: 1 }}>{field.bullet2}</span>
                         </Typography>
                     )
                   } else if (field.type === 'PhysicalTherapistDialog') {
                    return (
                      <Box sx={{ width: '100%', padding: '20px' }}>
                        <PhysicalTherapistDialog
                          assessmentRecords={assessmentRecords}
                          setAssessmentRecords={setAssessmentRecords}
                          open={dialogOpen}
                          onOpen={() => setDialogOpen(true)}
                          onClose={() => setDialogOpen(false)}
                          disabled={field?.isDisabled}
                        />
                      </Box>
                    )
                  }else if (field.type === 'SpeechTherapyDialog') {
                    return (
                      <Box sx={{ width: '100%', padding: '20px' }}>
                        <SpeechTherapyDialog
                          goalRecords={goalRecords}
                          setGoalRecords={setGoalRecords}
                          open={dialogOpen}
                          onOpen={() => setDialogOpen(true)}
                          onClose={() => setDialogOpen(false)}
                          isDisabled={field?.isDisabled}
                        />
                      </Box>
                    )
                  }
                  else if (field.type === 'NursesAssessmentDialog') {
                    return (
                      <Box sx={{ width: '100%', padding: '20px' }}>
                        <NursesAssessmentDialogue
                          nursesAssessmentRecords={data?.painAsessment || []}
                          setNursesAssessmentRecords={(records) => {
                            if (setFormValues) {
                              setFormValues((prev) => ({
                                ...prev,
                                painAsessment: records,
                              }));
                            }
                          }}
                          open={nursesAssessmentDialogOpen}
                          onOpen={() => setNursesAssessmentDialogOpen(true)}
                          onClose={() => setNursesAssessmentDialogOpen(false)}
                          isDisabled={field?.isDisabled || disabled}
                        />
                      </Box>
                    )
                  }
                  else if (field.type === 'VascularAccessDialog') {
                    return (
                      <Box sx={{ width: '100%', padding: '20px' }}>
                        <VascularAccessDialogue
                          vascularAccessRecords={data?.vascularAcess || []}
                          setVascularAccessRecords={(records) => {
                            if (setFormValues) {
                              setFormValues((prev) => ({
                                ...prev,
                                vascularAcess: records,
                              }));
                            }
                          }}
                          open={vascularAccessDialogOpen}
                          onOpen={() => setVascularAccessDialogOpen(true)}
                          onClose={() => setVascularAccessDialogOpen(false)}
                          isDisabled={field?.isDisabled || disabled}
                        />
                      </Box>
                    )
                  }
                  else if (field.type === 'CaregiverNotesDialog') {
                    return (
                      <Box sx={{ width: '100%', padding: '20px' }}>
                        <CaregiverNotesDialog
                           goalName={formData?.goalName || []}
                           setGoalName={(updatedGoals) =>
                            setFormData((prev) => ({
                              ...prev,
                              goalName: updatedGoals,
                            }))
                           }
                          open={dialogOpen}
                          onOpen={() => setDialogOpen(true)}
                          onClose={() => setDialogOpen(false)}
                          isDisabled={field?.isDisabled}
                        />
                      </Box>
                    )
                  }else if (field.type === 'WoundDialog') {
                    return (
                      <Box sx={{ width: '100%', padding: '20px' }}>
                          <WoundDialog
                            woundRecords={woundRecords as any}
                            setWoundRecords={setWoundRecords as any}
                            open={woundDialogOpen}
                            onOpen={() => setWoundDialogOpen(true)}
                            onClose={() => setWoundDialogOpen(false)}
                          />
                      </Box>
                    )
                  } else if (field.type === 'number') {
                    return (
                      <div
                        key={field.name}
                        className={`col-12 col-sm-6 col-md-6 
                          ${fieldsInRow.length === 1 && 'col-lg-12 col-md-12 col-sm-12'}
                           ${fieldsInRow.length === 2 && 'col-lg-6 col-md-6 col-sm-6'}
                           ${fieldsInRow.length === 3 && 'col-lg-4 col-md-4 col-sm-4'}
                           ${fieldsInRow.length === 4 && 'col-lg-2 col-md-2 col-sm-2'}
                           ${
                             fieldsInRow.length === 5 &&
                             field.label === 'Wage' &&
                             'col-lg-3 col-md-3 col-sm-2'
                           }`}
                      >
                        <TextField
                          defaultValue={field.defaultValue ? field.defaultValue : undefined}
                          label={field.label}
                          variant='outlined'
                          type={field.type}
                          size='small'
                          name={field.name}
                          value={field.value ? field.value : formData[field.name] || ''}
                          disabled={disabled}
                          onChange={(e) => {
                            if (field.onChange) {
                              field.onChange(
                                e.target.name,
                                e.target.value,
                                '',
                                e.target.type,
                                field.index
                              )
                            }
                            handleInputChange(e.target.name, e.target.value, '', e.target.type)
                          }}
                          required={field.required || false}
                          className='textField'
                          error={Boolean(
                            field.validation &&
                              formData[field.name] &&
                              !field.validation.pattern.test(formData[field.name])
                          )}
                          helperText={
                            field.validation &&
                            formData[field.name] &&
                            !field.validation.pattern.test(formData[field.name])
                              ? field.validation.message
                              : ''
                          }
                        />
                      </div>
                    )
                  } else if (field.type === 'socialSecurityNumber'){
                    return (
                      <div
                        key={field.name}
                        className={`col-12 col-sm-6 col-md-6 
                          ${fieldsInRow.length === 1 && 'col-lg-12 col-md-12 col-sm-12'}
                           ${fieldsInRow.length === 2 && 'col-lg-6 col-md-6 col-sm-6'}
                           ${fieldsInRow.length === 3 && 'col-lg-4 col-md-4 col-sm-4'}
                           ${fieldsInRow.length === 4 && 'col-lg-2 col-md-2 col-sm-2'}
                          `}
                      >     
                      <SocialSecurityNumberField 
                        formData={formData}
                        handleInputChange={handleInputChange}
                        field={field} 
                    />
                    </div>
                    )
                  }
                  if (field.type === 'numberOnly') {
                    return (
                      <div
                        key={field.name}
                        className={`col-12 col-sm-6 col-md-6 
                          ${fieldsInRow.length === 1 && 'col-lg-12 col-md-12 col-sm-12'}
                           ${fieldsInRow.length === 2 && 'col-lg-6 col-md-6 col-sm-6'}
                           ${fieldsInRow.length === 3 && 'col-lg-4 col-md-4 col-sm-4'}`}
                      >
                        <NumberField
                          formData={formData}
                          handleInputChange={handleInputChange}
                          field={field}
                          disabled={disabled}
                        />
                      </div>
                    )
                  } else if (field.type === 'textarea') {
                    return (
                      <div
                        key={field.name}
                        className={
                          field?.className
                            ? field.className
                            : 'col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'
                        }
                      >
                        <TextField
                          multiline
                          rows={4}
                          value={field?.value ? field.value : formData[field.name] || ''}
                          onChange={(e) => {
                            if (field.onChange) {
                              field.onChange(
                                e.target.name,
                                e.target.value,
                                '',
                                e.target.type,
                                field.index
                              )
                            }
                            handleInputChange(e.target.name, e.target.value, '', e.target.type)
                          }}
                          name={field.name}
                          label={field.label}
                          placeholder={field.placeholder || field.label}
                          disabled={field?.disabled || disabled}
                          required={field.required || false}
                          size="small"
                          fullWidth
                          variant="outlined"
                          className={
                            field?.textAreaClassName ? field.textAreaClassName : ''
                          }
                          style={{resize: 'none'}}
                        />
                      </div>
                    )
                  }else if (field.type === 'smartTextarea') {
                    return (
                      <div
                        key={field.name}
                        className={
                          field?.className
                            ? field.className
                            : 'col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'
                        }
                      >
                        <SmartTextarea
                          formData={formData}
                          setFormData={setFormData}
                          field={field}
                          disabled={disabled}
                        />
                      </div>
                    )
                  }else if (field.type === 'date') {
                    return (
                      <div
                        key={field.name}
                        className={
                          field?.className
                            ? field.className
                            : `col-12 col-sm-6 col-md-6 
                                ${fieldsInRow.length === 1 && 'col-lg-12 col-md-12 col-sm-12'}
                                ${fieldsInRow.length === 2 && 'col-lg-6 col-md-6 col-sm-6'}
                                ${fieldsInRow.length === 3 && 'col-lg-4 col-md-4 col-sm-4'}
                                ${fieldsInRow.length === 4 && 'col-lg-3 col-md-3 col-sm-2'}
                                ${fieldsInRow.length === 5 && field.label === 'Effective Date' && 'col-lg-2 col-md-2 col-sm-2'}`
                        }
                      >
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            label={field.label}
                            value={formData[field.name] ? dayjs(formData[field.name]) : null}
                            format='MM-DD-YYYY'
                            onChange={(newValue: any) => {
                              const newDate = formatToMMDDYYYY(newValue);
                              field.onChange
                                ? field.onChange(newDate, field.index)
                                : handleInputChange(field.name, newDate, '', 'date');
                            }}
                            slotProps={{
                              field:{
                                readOnly: true,
                              },
                              textField: { 
                                size: 'small', 
                                required: field?.required, 
                                disabled: field?.disabled, 
                                // error: false, 
                                style: { width: '100%' },  
                                inputProps: { 
                                  style: { cursor: 'pointer' },
                                  readOnly: true,
                                },
                                onClick: (e) => {
                                  // Prevent the click from bubbling up and trigger the date picker
                                  e.preventDefault();
                                  e.stopPropagation();
                                  // Find and click the calendar icon to open the picker
                                  const iconButton = e.currentTarget.querySelector('[data-testid="OpenPickerIconButton"]') || 
                                                   e.currentTarget.querySelector('.MuiIconButton-root');
                                  if (iconButton) {
                                    (iconButton as HTMLElement).click();
                                  }
                                }
                              },
                            }}
                            disabled={field?.disabled}
                            shouldDisableDate={(date: any) => {
                              if (field?.minDate || field?.maxDate) {
                                const minDate = field?.minDate
                                  ? new Date(
                                      field.minDate.getFullYear(),
                                      field.minDate.getMonth(),
                                      field.minDate.getDate()
                                    )
                                  : null;
                            
                                const maxDate = field?.maxDate
                                  ? new Date(
                                      field.maxDate.getFullYear(),
                                      field.maxDate.getMonth(),
                                      field.maxDate.getDate()
                                    )
                                  : null;
                            
                                if (minDate && date < minDate) return true;
                                if (maxDate && date > maxDate) return true;
                              }
                            
                              return false;
                            }}
                            sx={{
                              '& .MuiInputBase-root': {
                                cursor: 'pointer',
                              },
                              '& .MuiInputBase-input': {
                                cursor: 'pointer',
                                WebkitTextFillColor: '#000000',
                              },
                              '& .MuiOutlinedInput-root': {
                                cursor: 'pointer',
                              },
                              '& .MuiIconButton-root': {
                                cursor: 'pointer',
                              },
                            }}

                          />
                        </LocalizationProvider>

                        {/* <CustomDatePicker
                          id={field.name}
                          label={field.label}
                          value={formData[field.name] || null}
                          initialValue={field.initialValue || null}
                          required={field.required || false}
                          format={field.format || 'MM-DD-YYYY'}
                          minDate={field.minDate || null}
                          maxDate={field.maxDate || null}
                          disabled={field.disabled || false}
                          // readOnly={field.readOnly || false}
                          error={formData[`${field.name}Error`] || false}
                          errorMessage={field.errorMessage || 'Please fill the required field'}
                          onChange={(date) => {
                            field.onChange
                              ? field.onChange(date, field.index)
                              : handleDateInputChange(field.name, date, '', 'date', field.required);
                          }}
                        
                        /> */}
                      </div>
                    );
                  }
                   else if (field.type === 'multiSelect') {
                    return (
                      <div
                        key={field.name}
                        className={`col-12 col-sm-6 col-md-6 ${
                          fieldsInRow.length === 1 && 'col-lg-12 col-md-12 col-sm-12'
                        }`}
                      >
                        <Autocomplete
                          multiple
                          id={field.name}
                          options={field.options}
                          size='small'
                          disableCloseOnSelect
                          forcePopupIcon={true}
                          isOptionEqualToValue={(option, value) => {
                            if (!value || !option) return false;
                            // Handle both string values and object values
                            if (typeof value === 'string') {
                              return option.value === value || option.label === value;
                            }
                            // Handle object values - compare both value and label properties
                            if (typeof value === 'object' && value !== null) {
                              return option.value === value.value || option.value === value.label;
                            }
                            return option.value === value.value;
                          }}
                          renderOption={(props, option, {selected}) => (
                            <li {...props}>
                              <Checkbox
                                icon={icon}
                                checkedIcon={checkedIcon}
                                style={{marginRight: 8}}
                                checked={selected}
                              />
                              {option.label}
                            </li>
                          )}
                          style={{maxWidth: '100%'}}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label={field.label}
                              placeholder={field.label}
                              error={field.name === 'roleId' && (!formData[field.name] || formData[field.name].length === 0)}
                              helperText={
                                field.name === 'roleId' && (!formData[field.name] || formData[field.name].length === 0)
                                  ? 'Please fill out this field' 
                                  : ''
                              }
                            />
                          )}
                          value={formData[field.name] || []}
                          onChange={(event, newValue) => {
                            const selectedValues: any = newValue?.map((option) => ({
                              label: option.label,
                              value: option.value,
                            }))
                            setSelectedOptions(selectedValues)
                            handleAutocompleteChange(field.name, selectedValues)
                          }}
                        />
                      </div>
                    )
                  } else if (field.type === 'select') {
                    return (
                      <div
                      key={field.name}
                        className={
                          field?.className
                            ? field.className
                            : `col-12 col-sm-6 col-md-6  ${
                                fieldsInRow.length === 1 && 'col-lg-12 col-md-12 col-sm-12'
                              }
                    ${fieldsInRow.length === 2 && 'col-lg-6 col-md-6 col-sm-6'}
                    ${fieldsInRow.length === 3 && 'col-lg-4 col-md-4 col-sm-4'}
                    ${
                      fieldsInRow.length === 4 &&
                      (field.label === 'Search Role' || field.label === 'Unit') &&
                      'col-lg-4 col-md-4 col-sm-4'
                    }
                    ${
                      fieldsInRow.length === 5 &&
                      (field.label === 'Search Role' || field.label === 'Unit') &&
                      'col-xl-3 col-lg-3 col-md-3 col-sm-3'
                    }`
                        }
                      >
                        <Autocomplete
                          disablePortal
                          id={field.name}
                          size='small'
                          options={field.options || []}
                          isOptionEqualToValue={(option, value) => {
                            if (!value || !option) return false;
                            // Handle both string values and object values
                            if (typeof value === 'string') {
                              return option.value === value || option.label === value;
                            }
                            return option.value === value.value;
                          }}
                          forcePopupIcon={true}
                          disabled={disabled || field?.disabled}
                          renderInput={(params) => (
                            <TextField
                            sx={field.sx || {}}
                            {...params}
                              error={field.error ? field.error : undefined}
                              helperText={field.helperText ? field.helperText : undefined}
                              required={field.required}
                              label={field.label}
                            />
                          )}
                          value={
                            field.value
                              ? field.value
                              : formData[field.name] !== undefined && formData[field.name] !== ''
                              ? field.options?.find(
                                  (option: {value: string}) => option.value === formData[field.name]
                                ) || null
                              : null}
                          onChange={(event, newValue) => {
                            const selectedValue = newValue ? newValue.value : ''
                            console.log(selectedValue)
                            handleAutocompleteChange(field.name, selectedValue)
                            if (field.onChange) {
                              field.onChange(selectedValue, field.index)
                            }
                          }}
                        />
                      </div>
                    );
                      } else if (field.type === 'searchableSelect') {
                        return (
                          <div
                          key={field.name}
                            className={
                              field?.className
                                ? field.className
                                : `col-12 col-sm-6 col-md-6  ${
                                    fieldsInRow.length === 1 && 'col-lg-12 col-md-12 col-sm-12'
                                  }
                        ${fieldsInRow.length === 2 && 'col-lg-6 col-md-6 col-sm-6'}
                        ${fieldsInRow.length === 3 && 'col-lg-4 col-md-4 col-sm-4'}
                        ${
                          fieldsInRow.length === 4 &&
                          (field.label === 'Search Role' || field.label === 'Unit') &&
                          'col-lg-4 col-md-4 col-sm-4'
                        }
                        ${
                          fieldsInRow.length === 5 &&
                          (field.label === 'Search Role' || field.label === 'Unit') &&
                          'col-xl-3 col-lg-3 col-md-3 col-sm-3'
                        }`
                            }
                          >
                            <SearchableSelect
                              label={field.label}
                              options={field.options || []}
                              value={formData[field.name] || field.value || null}
                              onChange={(newValue) => {
                                handleSearchableSelectChange(field.name, newValue)
                              }}
                              disabled={disabled || field?.disabled}
                              fullWidth={true}
                              required={field.required}
                            />
                          </div>
                        );
                    } else if (field.type === 'radio') {
                    return (
                      <div key={field.name} className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                        <FormControl
                          key={field.name}
                          component='fieldset'
                          // className={classes.radioGroup}
                        >
                          <InputLabel shrink>{field.label}</InputLabel>
                          <RadioGroup
                            name={field.name}
                            value={formData[field.name] || ''}
                            row={`${field.name === 'availability'}` ? true : false}
                            onChange={(e) =>
                              handleInputChange(e.target.name, e.target.value, true, e.target.type)
                            }
                          >
                            {field.options?.map((option: any) => (
                              <FormControlLabel
                                key={option.value}
                                disabled={field?.disabled}
                                value={option.value}
                                control={<Radio required={field.required || false} />}
                                label={option.label}
                                className='radioLabel'
                              />
                            ))}
                          </RadioGroup>
                        </FormControl>
                      </div>
                    )
                  } else if (field.type === 'checkbox') {
                    return (
                      <div key={field.name} className='col-12'>
                        <FormControl component='fieldset' fullWidth>
                          <InputLabel component="legend" sx={{ mb: 2, fontWeight: '500' }}>{field.label}</InputLabel>
                          <Grid container>
                            {field.options?.map((option: any) => (
                              <Grid item xs={12} sm={6} md={4} lg={3} key={option.value}>
                                <FormControlLabel
                                  label={option.label}
                                  labelPlacement='end'
                                  sx={{
                                    '&.Mui-disabled': {
                                      '& .MuiFormControlLabel-label': {
                                        color: 'rgba(0, 0, 0, 0.6) !important',
                                      },
                                    },
                                  }}
                                  control={
                                    <Checkbox
                                      name={field.name}
                                      value={option.value}
                                      checked={
                                        (Array.isArray(formData[field.name]) && formData[field.name].includes(option.value)) ||
                                        (!Array.isArray(formData[field.name]) && formData[field.name] === option.value) ||
                                        (field.defaultValue === option.value)
                                      }
                                      disabled={typeof field.disabled === 'function' ? field.disabled(option) : field.disabled}
                                      onChange={(e) => {
                                        handleInputChange(
                                          e.target.name,
                                          e.target.value,
                                          e.target.checked,
                                          field.type
                                        )
                                      }}
                                    />
                                  }
                                />
                              </Grid>
                            ))}
                          </Grid>
                        </FormControl>
                      </div>
                    )
                  } else if (field.type === 'checkboxBoolean') {
                    return (
                      // <div key={field.name} className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                      <div key={field.name} className='col-12 col-md-4 col-lg-4 col-xl-4'>
                        <FormControl
                          disabled={field?.disabled || false}
                          key={field.name}
                          component='fieldset'
                          sx={{display: 'flex', flexDirection: 'row'}}
                        >
                          <InputLabel shrink>{field.label}</InputLabel>
                          {field.options?.map((option: any) => (
                            <FormControlLabel
                              key={option.value}
                              label={option.label}
                              labelPlacement='end'
                              control={
                                <Checkbox
                                  name={field.name}
                                  value={option.value}
                                  checked={formData[field.name] || false}
                                  onChange={(e) =>
                                    handleInputChange(
                                      e.target.name,
                                      e.target.value,
                                      e.target.checked,
                                      field.type
                                    )
                                  }
                                />
                              }
                            />
                          ))}
                        </FormControl>
                      </div>
                    )
                  } else if (field.type === 'asyncSelectICD') {
                    return (
                      <div key={field.name} className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                        <GetICDValues
                          field={field}
                          handleInputChange={handleInputChange}
                          initialValue={formData}
                        ></GetICDValues>
                      </div>
                    )
                  } else if (field.type === 'image') {
                    return (
                      <div key={field.name} className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                        <input
                          type='file'
                          accept='image/*'
                          id='image-input'
                          className='textField'
                          onChange={handleImageChange}
                        />

                        {selectedImage && (
                          <div
                            style={{
                              position: 'relative',
                              display: 'flex',
                              margin: '10px',
                            }}
                          >
                            <CardMedia
                              component='img'
                              alt='Selected'
                              height='120px'
                              width='100px'
                              image={selectedImage}
                            />
                            <ClearIcon
                              style={{
                                position: 'absolute',
                                top: '5px',
                                left: '5px',
                                backgroundColor: 'lightgray',
                                color: 'white',
                                border: 'none',
                                cursor: 'pointer',
                                padding: '5px',
                              }}
                              onClick={handleDeleteImage}
                            />
                          </div>
                        )}
                      </div>
                    )
                  } else if (field.type === 'file') {
                    return (
                      <div key={field.name} className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                        <div>
                          <input
                            type='file'
                            accept='.pdf, application/pdf, .xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, .docx, application/vnd.openxmlformats-officedocument.wordprocessingml.document, text/csv '
                            id='file-input'
                            onChange={(event) => handleFileChange(event)}
                          />
                          {selectedFile && (
                            <div
                              style={{
                                position: 'relative',
                                display: 'flex',
                                margin: '10px',
                              }}
                            >
                              {selectedFile.type.startsWith('image/') ? (
                                <img src={filePreview} alt='Selected File' />
                              ) : (
                                <iframe
                                  src={filePreview}
                                  title='Selected File'
                                  width='200'
                                  height='180'
                                />
                              )}
                              <ClearIcon
                                style={{
                                  position: 'absolute',
                                  top: '5px',
                                  left: '5px',
                                  backgroundColor: 'lightgray',
                                  color: 'white',
                                  border: 'none',
                                  cursor: 'pointer',
                                  padding: '5px',
                                }}
                                onClick={(file) => {
                                  //  setSelectedFile(null);
                                  //     const file = formData.file
                                  //     axios.delete('/deleteFile/' + file)
                                  //     .then(response => {
                                  //         console.log(response.data.message);
                                  //          setFormData((prevFormData) => ({
                                  //     ...prevFormData,
                                  //     file: null,
                                  //   }))
                                  //     })
                                  //     .catch(error => {
                                  //         console.error(error);
                                  //         // Handle errors here
                                  //     });
                                  //     setFilePreview(null);
                                }}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    )
                  } else if (field.type === 'timezone-time') {
                    return (
                      <div
                        key={field.name}
                        className={
                          field?.className
                            ? field.className
                            : `col-12 col-sm-6 col-md-6 
                      ${fieldsInRow.length === 1 && 'col-lg-12 col-md-12 col-sm-12'}
                      ${fieldsInRow.length === 2 && 'col-lg-6 col-md-6 col-sm-6'}
                      ${fieldsInRow.length === 3 && 'col-lg-4 col-md-4 col-sm-4'}
                      ${fieldsInRow.length === 4 && 'col-lg-3 col-md-3 col-sm-2'}
                      ${
                        fieldsInRow.length === 5 &&
                        field.label === 'Time' &&
                        'col-lg-3 col-md-3 col-sm-2'
                      }`
                        }
                      >
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <TimePicker
                            label={field.label}
                            minutesStep={field.minutesStep}
                            value={
                              formData[field.name]
                                ? dayjs.tz(formData[field.name], 'UTC').tz(timeZone)
                                : null
                            }
                            onChange={(e) => {
                              const localizedTime = dayjs.tz(e, timeZone);
                              console.log(localizedTime.toDate())
                              field.onChange
                                ? field.onChange(
                                    field.name,
                                    localizedTime.toDate(),
                                    '',
                                    field.type,
                                    field.index
                                  )
                                : handleInputChange(field.name, localizedTime.toDate(), '', field.type);
                            }}
                            slotProps={{
                              field:{
                                readOnly: true,
                              },
                              textField: {
                                size: 'small',
                                disabled: false,
                                style: { width: '100%' },
                                InputProps: {
                                  readOnly: true,
                                  style: { cursor: 'pointer' },
                                },
                                onClick: (e) => {
                                  // Prevent the click from bubbling up and trigger the date picker
                                  e.preventDefault();
                                  e.stopPropagation();
                                  // Find and click the calendar icon to open the picker
                                  const iconButton = e.currentTarget.querySelector('[data-testid="OpenPickerIconButton"]') || 
                                                   e.currentTarget.querySelector('.MuiIconButton-root');
                                  if (iconButton) {
                                    (iconButton as HTMLElement).click();
                                  }
                                }
                              },
                            }}
                            sx={{
                              '& .MuiInputBase-input': {
                                WebkitTextFillColor: '#000000',
                                cursor: 'pointer',
                              },
                              '& .MuiOutlinedInput-root': {
                                cursor: 'pointer',
                              },
                              '& .MuiIconButton-root': {
                                cursor: 'pointer',
                              },
                              '& .MuiClock-pin': {
                                backgroundColor: '#1976d2',
                              },
                              '& .MuiClockPointer-root': {
                                backgroundColor: '#1976d2',
                                '& .MuiClockPointer-thumb': {
                                  backgroundColor: '#1976d2',
                                  borderColor: '#1976d2',
                                },
                              },
                              '& .MuiPaper-root': {
                                boxShadow: '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)',
                                borderRadius: '4px',
                                overflow: 'hidden',
                                marginTop: '4px',
                              },
                              '& .MuiClock-root': {
                                pointerEvents: 'auto',
                              },
                              '& .MuiClockNumber-root': {
                                pointerEvents: 'auto',
                              },
                              '@media (max-width: 600px)': {
                                '& .MuiPickersPopper-paper': {
                                  position: 'fixed !important',
                                  top: 'auto !important',
                                  left: '50% !important',
                                  transform: 'translateX(-50%) !important',
                                  width: 'calc(100% - 32px) !important',
                                  maxWidth: '360px !important',
                                  margin: '0 auto !important',
                                },
                              },
                            }}
                            ampm={true}
                            views={['hours', 'minutes']}
                          />
                        </LocalizationProvider>
                      </div>
                    )
                  } else if (field.type === 'string-time') {
                    return (
                      <div
                        key={field.name}
                        className={
                          field?.className
                            ? field.className
                            : `col-12 col-sm-6 col-md-6 
                        ${fieldsInRow.length === 1 && 'col-lg-12 col-md-12 col-sm-12'}
                        ${fieldsInRow.length === 2 && 'col-lg-6 col-md-6 col-sm-6'}
                        ${fieldsInRow.length === 3 && 'col-lg-4 col-md-4 col-sm-4'}
                        ${fieldsInRow.length === 4 && 'col-lg-3 col-md-3 col-sm-2'}
                        ${
                          fieldsInRow.length === 5 &&
                          field.label === 'Time' &&
                          'col-lg-3 col-md-3 col-sm-2'
                        }`
                        }
                      >
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <TimePicker
                            label={field.label}
                            minutesStep={field.minutesStep}
                            value={
                              formData[field.name]
                                ? dayjs(`${dayjs().format('YYYY-MM-DD')} ${formData[field.name]}`, 'YYYY-MM-DD hh:mm A')
                                : null
                            }
                            ampm={true}
                            disabled={field.disabled}
                            onChange={(e) => {
                              if (e) {
                                const timeString = dayjs(e).format('HH:mm A');
                                field.onChange
                                  ? field.onChange(
                                      field.name,
                                      timeString,
                                      '',
                                      field.type,
                                      field.index
                                    )
                                  : handleInputChange(field.name, timeString, '', field.type);
                              } 
                            }}
                            slotProps={{
                              field:{
                                readOnly: true
                              },
                              textField: {
                                size: 'small',
                                disabled: false,
                                style: { 
                                  width: '100%',
                                },
                                InputProps: {
                                  readOnly:  true, 
                                  style: { cursor: 'pointer' },
                                },
                                onClick: (e) => {
                                  // Prevent interaction if disabled                      
                                  e.preventDefault();
                                  e.stopPropagation();
                                  const iconButton = e.currentTarget.querySelector('[data-testid="OpenPickerIconButton"]') || 
                                                   e.currentTarget.querySelector('.MuiIconButton-root');
                                  if (iconButton) {
                                    (iconButton as HTMLElement).click();
                                  }
                                }
                              },
                            }}
                            sx={{
                              '& .MuiInputBase-input': {
                               WebkitTextFillColor: '#000000',
                               cursor: 'pointer',
                              },
                              '& .MuiOutlinedInput-root': {
                               cursor: 'pointer',
                              },
                              '& .MuiIconButton-root': {
                                cursor: 'pointer',
                              },
                              '& .MuiClock-pin': {
                                backgroundColor: '#1976d2',
                              },
                              '& .MuiClockPointer-root': {
                                backgroundColor: '#1976d2',
                                '& .MuiClockPointer-thumb': {
                                  backgroundColor: '#1976d2',
                                  borderColor: '#1976d2',
                                },
                              },
                              '& .MuiPaper-root': {
                                boxShadow: '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)',
                                borderRadius: '4px',
                                overflow: 'hidden',
                                marginTop: '4px',
                              },
                              '& .MuiClock-root': {
                               pointerEvents: 'auto', 
                              },
                              '& .MuiClockNumber-root': {
                               pointerEvents: 'auto', 
                              },
                              '@media (max-width: 600px)': {
                                '& .MuiPickersPopper-paper': {
                                  position: 'fixed !important',
                                  top: 'auto !important',
                                  left: '50% !important',
                                  transform: 'translateX(-50%) !important',
                                  width: 'calc(100% - 32px) !important',
                                  maxWidth: '360px !important',
                                  margin: '0 auto !important',
                                },
                              },
                            }}
                            views={['hours', 'minutes']}
                          />
                        </LocalizationProvider>
                      </div>
                    )
                  } else if (field.type === 'time') {
                    return (
                      <div
                        key={field.name}
                        className={
                          field?.className
                            ? field.className
                            : `col-12 col-sm-6 col-md-6 
                      ${fieldsInRow.length === 1 && 'col-lg-12 col-md-12 col-sm-12'}
                      ${fieldsInRow.length === 2 && 'col-lg-6 col-md-6 col-sm-6'}
                      ${fieldsInRow.length === 3 && 'col-lg-4 col-md-4 col-sm-4'}
                      ${fieldsInRow.length === 4 && 'col-lg-3 col-md-3 col-sm-2'}
                      ${
                        fieldsInRow.length === 5 &&
                        field.label === 'Time' &&
                        'col-lg-3 col-md-3 col-sm-2'
                      }`
                        }
                      >
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <TimePicker
                            label={field.label}
                            minutesStep={field.minutesStep}
                            value={formData[field.name] ? dayjs(formData[field.name]) : ''}
                            onChange={(e) => {
                              console.log(dayjs(e).toDate())
                              field.onChange
                                ? field.onChange(
                                    field.name,
                                    dayjs(e).toDate(),
                                    '',
                                    field.type,
                                    field.index
                                  )
                                : handleInputChange(field.name, dayjs(e).toDate(), '', field.type)
                            }}
                            slotProps={{
                              field:{
                                readOnly: true,
                              },
                              textField: {
                                size: 'small',
                                disabled: true,
                                style: {width: '100%'},
                                InputProps: {
                                  readOnly: true,
                                  style: { cursor: 'pointer' },
                                },
                                onClick: (e) => {
                                  // Prevent the click from bubbling up and trigger the date picker
                                  e.preventDefault();
                                  e.stopPropagation();
                                  // Find and click the calendar icon to open the picker
                                  const iconButton = e.currentTarget.querySelector('[data-testid="OpenPickerIconButton"]') || 
                                                   e.currentTarget.querySelector('.MuiIconButton-root');
                                  if (iconButton) {
                                    (iconButton as HTMLElement).click();
                                  }
                                }
                              },
                            }}
                            sx={{
                              '& .MuiInputBase-input.Mui-disabled': {
                                WebkitTextFillColor: '#000000',
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </div>
                    )
                  } else if (field.type === 'button') {
                    return (
                      <div
                        key={field.name}
                        className={`col-12 col-sm-6 col-md-6  ${
                          fieldsInRow.length === 1 && 'col-lg-12 col-md-12 col-sm-12'
                        }
                        ${fieldsInRow.length === 2 && 'col-lg-6 col-md-6 col-sm-6'}
                        ${fieldsInRow.length === 3 && 'col-lg-4 col-md-4 col-sm-4'}
                        ${fieldsInRow.length === 4 && 'col-lg-1 col-md-1 col-sm-2'}
                        ${fieldsInRow.length === 5 && 'col-lg-1 col-md-1 col-sm-1'}`}
                      >
                        <Button
                          key={index}
                          type={field.type}
                          sx={
                            field.label === 'Delete'
                              ? {justifyContent: 'flex-end'}
                              : {padding: '4px', margin: '4px'}
                          }
                          variant={field.variant}
                          className={field.type === 'submit' ? 'submitButton' : 'cancelButton'}
                          onClick={
                            field.label === 'Cancel'
                              ? field.onClick
                                ? () => field.onClick(field.index)
                                : () => history.goBack()
                              : field.onClick
                          }
                        >
                          {field.label}
                        </Button>
                      </div>
                    )
                  } else if (field.type === 'textLabel') {
                    return (
                      <div
                        key={field.name}
                        className={`col-12 col-sm-6 col-md-6  ${
                          fieldsInRow.length === 1 && 'col-lg-12 col-md-12 col-sm-12'
                        }
                        ${fieldsInRow.length === 2 && 'col-lg-6 col-md-6 col-sm-6'}
                        ${fieldsInRow.length === 3 && 'col-lg-4 col-md-4 col-sm-4'}
                        ${fieldsInRow.length === 4 && 'col-lg-2 col-md-2 col-sm-2'}
                        ${fieldsInRow.length === 5 && 'col-lg-1 col-md-1 col-sm-1'}`}
                      >
                        <span className='h5'>{`${field.label} : `}</span>
                        <span style={{marginLeft: '10px'}}>{field.value}</span>
                      </div>
                    )
                  }
                  return null
                })}
              </div>
            </div>
          )
        })}
        <Box className='root'>
          <Box className='buttonContainer'>
            {buttons?.map((button: any, index: React.Key | null | undefined) =>
              button.disabled === true ? (
                <div></div>
              ) : (
                <Button
                  key={index}
                  type={button.type}
                  sx={{padding: '4px', margin: '4px'}}
                  variant={button.variant}
                  className={button.type === 'submit' ? 'submitButton' : 'cancelButton'}
                  onClick={
                    button.label === 'Cancel'
                      ? button.onClick
                        ? () => button.onClick(button.index)
                        : () => history.goBack()
                      : button.onClick
                      ? () => button.onClick(button.index)
                      : () => {}
                  }
                  disabled={isLoading || button.disabled}
                >
                  {button.label}
                </Button>
              )
            )}
          </Box>
        </Box>
      </form>
    </>
  )
}

export default DynamicForm
